<form *ngIf="fields" [ngClass]="{'invalid-submit': invalidSubmit}" [formGroup]="addEditFormSupBrand" (ngSubmit)="saveOrUpdate()" RestrictFocus>

  <div class="ui-grid ui-grid-responsive ui-fluid">

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.brand_id.nullable}">{{ fields.brand_name.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <p-dropdown [style]="{'width':'100%'}" formControlName="brand_id" [options]="brand_items" [(ngModel)]="selected_brand"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditFormSupBrand" [validation]="fields.brand_id"></app-validation-msg>
      </div>
    </div>

  </div>

  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0; margin-top: 15px;">
      <button class="k-generic-btn" type="submit" pButton icon="fa fa-check" [label]="('common.add' | translate)"> </button>
    </div>
  </p-footer>

</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/supplier/supplier-brand/supplier-brand-form.component.html